module.exports = __webpack_public_path__ + "img/40_69_001_500.390b01cb.jpg";